export default __webpack_public_path__ + "static/media/ba7.75a8bee2.jpg";